import {fetchApi} from "../fetch";
import {API_URL} from "../../constants/axios";


export const getMessageStatistics = async (automateName, entryPointId, startDate, endDate) => {
    const searchParams = new URLSearchParams()
    if (automateName) {
        searchParams.append('automateName', automateName)
    }
    if (entryPointId) {
        searchParams.append('entryPointId', entryPointId)
    }
    if (startDate) {
        searchParams.append('startDate', startDate)
    }
    if (endDate) {
        searchParams.append('endDate', endDate)
    }
    const res = await fetchApi.get(`${API_URL.MESSAGE_STATISTICS}?${searchParams.toString()}`)

    return res.data
};